import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка актов сверка
    async getReconciliationActs(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`reconciliation_acts?${params.toString()}${sorting}`);
    },
    // Получение акта сверки по id
    async getReconciliationActById(id) {
      return await this.get(`reconciliation_acts/${id}`);
    },
    // Создание акта сверки
    async postReconciliationAct(data) {
      return await this.post('reconciliation_acts', data);
    },
    // Изменение акта сверки
    async putReconciliationAct(data) {
      return await this.put(`reconciliation_acts/${data.id}`, data);
    },
    // Получение деталей акта сверки
    async getReconciliationActDetails(data) {
      let params = this.makeSearchParams(data);

      if (data.start_date) {
        const serverDate = this.getDateToServer(data.start_date).toISOString();
        params.set("start_date", serverDate);
      }

      if (data.end_date) {
        const serverDate = this.getDateToServer(data.end_date).toISOString();
        params.set("end_date", serverDate);
      }

      if (data.organization_id) {
        params.set("organization_id", data.organization_id);
      }

      if (data.customer_id) {
        params.set("customer_id", data.customer_id);
      }

      return await this.get(`reconciliation_acts/details?${params.toString()}`);
    },
    async getReconciliationActFile(data) {
      return await this.getFile(`reconciliation_acts/${data.id}/document/${data.exportType}?hasStamp=${data.hasStamp}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/network/reconciliationActs.js